import { module } from './store'
import { createModule } from '@vue-storefront/core/lib/module'

const KEY = 'myaccount'

export const MyAccount = createModule({
  key: KEY,
  store: { modules: [{ key: KEY, module }] }
})
